import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AllHistoryState, PatientHistoryResponse } from "./index.types";

export const initialAllHistoryState: AllHistoryState = {
  allHistorySuccess: false,
  allHistoryData: {},
  allHistoryIsLoading: false,
};

const name = "allHistory";

export const allHistorySlice = createSlice({
  name,
  initialState: initialAllHistoryState,
  reducers: {
    getAllHistory: (state) => {
      state.allHistoryIsLoading = true;
    },
    getAllHistorySuccess: (state, action: PayloadAction<PatientHistoryResponse>) => {
      state.allHistorySuccess = true;
      state.allHistoryIsLoading = false;
      state.allHistoryData = action.payload;
    },
    getAllHistoryFail: (state) => {
      state.allHistorySuccess = false;
      state.allHistoryData = {};
      state.allHistoryIsLoading = false;
    },
    clearAllHistoryData: (state) => {
      state.allHistorySuccess = false;
      state.allHistoryData = {};
      state.allHistoryIsLoading = false;
    },
  },
});

export const { getAllHistory, clearAllHistoryData } = allHistorySlice.actions;

export default allHistorySlice.reducer;

export const getAllHistoryList = (patientId: string | number) => ({
  payload: {
    apiName: name,
    method: "get",
    url: `/api/patients/${patientId}/all-history/`,
  },
  type: "getAllHistory",
});
